<div class="modal-header">
  <h3 class="modal-title">Add non share consideration type</h3>
</div>
<div class="modal-body">
  <magieno-input-text-field [advancedFormControl]="title"
                        type="string"></magieno-input-text-field>
</div>
<div class="modal-footer">
  <button (click)="cancel()" class="btn btn-light" data-bs-dismiss="modal" type="button">Annuler</button>
  <button (click)="activeModal.close(true)" class="btn btn-danger" type="button">Ajouter</button>
</div>
